jQuery( document ).ready(function() {
			  
  var sizeUs = "";
  jQuery( "label.btooltip" ).each(function() {
  	var size = jQuery( this ).attr( "title" );

	switch (size) {
        case '33':
	  		sizeUs = '2½-3';
        	break;
    	case '34':
	  		sizeUs = '3½-4';
	    	break;
    	case '35':
	  		sizeUs = '4½-5';
        	break;
    	case '36':
	  		sizeUs = '5½-6';
	    	break;
    	case '37':
	  		sizeUs = '6½-7';
	    	break;
    	case '38':
	  		sizeUs = '7½-8';
	    	break;
    	case '39':
	  		sizeUs = '8½-9';
	    	break;
    	case '40':
	  		sizeUs = '9½';
	    	break;
    	case '41':
	  		sizeUs = '10-10½';
	    	break;
    	case '42':
	  		sizeUs = '11';
	    	break;
        case '43':
	  		sizeUs = '12';
	    	break;
	  default:
	    console.log('No size found');
	}

    jQuery(this ).text( size + " ( US " + sizeUs  + " )");
  });

});
